var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-header"},_vm._l((_vm.columnTitlesWithFirstEmptyColumn),function(title,index){return _c('div',{key:index,staticClass:"table-header__title",style:(_vm.cssVars)},[_vm._v(" "+_vm._s(title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }